// extracted by mini-css-extract-plugin
module.exports = {"marginBottom":"CodeSnippet_marginBottom__D0slM","overrides":"CodeSnippet_overrides__EtB_k","homepage":"CodeSnippet_homepage__XJ8r8"};